<div class="flex flex-col gap-y-4 overflow-hidden">
  <div class="flex justify-between items-end">
    <div class="font-semibold text-xl text-(--color-text-primary)">
      {{ 'filters.title' | translate }}
    </div>

    <button
      (click)="closeModal()"
      class="border! rounded-full border-(--comp-dialog-button-close)!"
      mat-icon-button
    >
      <mat-icon class="text-(--comp-dialog-button-close)!">close</mat-icon>
    </button>
  </div>

  <div class="flex-col flex p-4">
    @if (statusSelected == 0) {
      <div class="flex gap-1 flex-col">
        <app-input-general-select
          [label]="'filters.filterBy'"
          [placeholder]="'filters.selectPlaceholder'"
          [arrayData]="SearchFields"
          [inputSelect]="{ description: 'Text', value: 'Value' }"
          [formControlGeneral]="SearchField"
        ></app-input-general-select>

        <app-input-general
          [label]="'filters.searchLabel'"
          [placeholder]="'filters.searchLabel'"
          [formControlGeneral]="SearchFieldValue"
        ></app-input-general>

        <app-input-general-select
          [label]="'filters.orderBy'"
          [placeholder]="'filters.orderByDate'"
          [arrayData]="orderSortAux"
          [inputSelect]="{ description: 'Text', value: 'Value' }"
          [formControlGeneral]="Sort"
        ></app-input-general-select>

        <app-input-general-select
          [label]="'filters.orderLabel'"
          [placeholder]="'filters.orderLabel'"
          [arrayData]="SortDirectionsArray"
          [inputSelect]="{ description: 'Text', value: 'Value' }"
          [formControlGeneral]="SortDirections"
        ></app-input-general-select>

        <div class="flex w-full gap-4 lg:flex-row flex-col justify-center items-center">
          <button>
            <div
              class="flex justify-center items-center gap-4 button-alternative w-min px-15!"
              matButton
              (click)="clearFilters()"
            >
              <div>{{ 'common.actions.clear' | translate }}</div>
            </div>
          </button>
          <button
            class="flex justify-center items-center gap-4 button-alternative w-min px-15!"
            matButton
            type="submit"
            [disabled]="
              !(
                (Sort.valid && SortDirections.valid) ||
                (SearchField.valid && SearchFieldValue.valid)
              ) ||
              Sort.valid !== SortDirections.valid ||
              SearchField.valid !== SearchFieldValue.valid
            "
            (click)="emitModalLocation()"
          >
            <div>{{ 'common.actions.search' | translate }}</div>
          </button>
        </div>
      </div>
    }
  </div>
</div>
